import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { getKeytipString, constructKeytip } from 'owa-command-ribbon';
import { getDefaultSlrAppRibbonButtonStyles } from 'owa-command-ribbon-styles';
import { MailRibbonControlId } from 'owa-ribbon-ids';
import { getControlInfo } from 'owa-mail-ribbon-utils';
import { onReplyAllClicked, onReplyClicked } from '../../../../util/commandActions';
import { createMailAppSplitButton } from '../../../../util/createMailRibbonButton';
import { getToolbarRibbonIconColor } from '../../../../util/getToolbarRibbonIconColor';
import { getRespondSections } from '../../../sections';
import type { ClientItemId } from 'owa-client-ids';
import { getReadRibbonId } from '../../../../util/getReadRibbonId';
import isReplyAllTheDefaultResponse from 'owa-mail-reading-pane-store/lib/utils/isReplyAllTheDefaultResponse';
import { getIsPopoutButtonDisabled } from '../../../../util/getIsPopoutButtonDisabled';

/**
 * This file contains the definitions for all the controls
 * in the toolbar ribbon
 */

export const getRespondControl = computedFn(
    (itemId?: ClientItemId, targetWindow?: Window): RibbonControlProps => {
        const isDefaultReplyAll = isReplyAllTheDefaultResponse();
        const controlInfo = getControlInfo(MailRibbonControlId.Respond);

        return createMailAppSplitButton(
            getReadRibbonId(MailRibbonControlId.Respond, itemId),
            controlInfo.text,
            controlInfo.ariaText,
            controlInfo.tooltip,
            itemId !== undefined /*isPopout*/,
            { sections: getRespondSections(itemId, targetWindow) },
            isDefaultReplyAll
                ? onReplyAllClicked(itemId, targetWindow)
                : onReplyClicked(itemId, targetWindow),
            constructKeytip([], getKeytipString(MailRibbonControlId.Respond), true /* hasMenu */),
            controlInfo.iconName,
            getToolbarRibbonIconColor() /*iconColor*/,
            getDefaultSlrAppRibbonButtonStyles(),
            {
                primaryDisabled: getIsPopoutButtonDisabled(
                    isDefaultReplyAll
                        ? MailRibbonControlId.RespondReplyAll
                        : MailRibbonControlId.RespondReply,
                    itemId
                ),
            }
        );
    }
);
